import { useCallback } from 'react';
import { pettyCashService } from '../services';
import {
  useResourceCollection,
  useResourceById,
  useCreateResource,
  useUpdateResource,
  useDeleteResource,
  ResourceState,
  SingleResourceState,
  MutationState,
} from './useResource';
import { ResourceQueryOptions } from '../services/resources.service';
import { PettyCash } from '../types';

export function usePettyCash(
  options?: ResourceQueryOptions
): ResourceState<PettyCash> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      pettyCashService.getAll(opts) as unknown as Promise<{ data: PettyCash[]; meta?: any }>,
    []
  );
  return useResourceCollection<PettyCash>(fetchFn, options);
}

export function usePettyCashById(
  id: string | null,
  options?: ResourceQueryOptions
): SingleResourceState<PettyCash> {
  const resourceId = id;
  const fetchFn = useCallback(
    (pettyCashId: string | number, opts?: ResourceQueryOptions) =>
      pettyCashService.getById(pettyCashId, opts) as unknown as Promise<PettyCash>,
    []
  );
  return useResourceById<PettyCash>(fetchFn, resourceId, options);
}

export function useCreatePettyCash(
  onSuccess?: (data: PettyCash) => void
): MutationState<PettyCash> {
  const createFn = useCallback(
    (data: any) => pettyCashService.create(data) as unknown as Promise<PettyCash>,
    []
  );
  return useCreateResource<PettyCash>(createFn, onSuccess);
}

export function useUpdatePettyCash(
  onSuccess?: (data: PettyCash) => void
): MutationState<PettyCash> {
  const updateFn = useCallback(
    (id: string | number, data: any) => {
      return pettyCashService.update(id, data) as unknown as Promise<PettyCash>;
    },
    []
  );
  return useUpdateResource<PettyCash>(updateFn, onSuccess);
}

export function useDeletePettyCash(onSuccess?: () => void): MutationState<void> {
  const deleteFn = useCallback(
    (data: any) => {
      const documentId = data.documentId || data.id?.toString() || data.id;
      return pettyCashService.delete(documentId) as unknown as Promise<void>;
    },
    []
  );
  return useDeleteResource(deleteFn, onSuccess);
}

